//setting
export var kFaceApiPathSettings = "/OeFS69/Ee4Ie6/VSWL82/Yth2FZ"; //login

export var kFaceApiPathLogin = "/62bdLH/Ee4Ie6/PuWlyQ/qYWn1G"; //user info

export var kFaceApiPathUserInfo = "/62bdLH/resJQs/XolrHk/CxfhS1"; //refresh token

export var kFaceApiPathRefreshToken = "/L1kPyV/W9HmXj/xQqGjm/1PIJw1"; //service iap

export var kFaceApiPathIapService = "/L1kPyV/W9HmXj/4zUQiJ/ZWkk3M"; //service list

export var kFaceApiPathIapServiceList = "/L1kPyV/W9HmXj/ZWkk3M/b8osLE"; //

export var kFaceApiPathFaceStart = "/api/v1/face/star";
export var ACCESS_TOKEN_EXPIRE = {
  httpCode: 400,
  errorCode: 20007,
  desc: "Access Token Expired."
};
export var REFRESH_TOKEN_EXPIRE = {
  httpCode: 400,
  errorCode: 20008,
  desc: "Refresh Token Expired."
};